exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uploadBox[data-v-16113cc1] .el-upload-list__item-thumbnail{width:44px !important;height:44px !important;margin-left:-83px !important;margin-top:-3px}.uploadBox[data-v-16113cc1] .el-upload-list__item-name{line-height:42px !important;margin-left:-36px !important;width:auto !important;margin-right:0 !important}.uploadBox[data-v-16113cc1] .el-upload-list__item{height:60px !important;background:#f5f5f5 !important;border:none;width:220px !important;margin-top:10px !important}.percent[data-v-16113cc1]{margin-top:20px}\n", ""]);

// exports
